// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"404":"344b65cf","937":"8141d9fb"}[chunkId] + ".css";
};